// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var GraphqlHelpers = require("../GraphqlHelpers.bs.js");
var CommonTypes_City = require("./CommonTypes_City.bs.js");
var CommonTypes_User_Id = require("./CommonTypes_User_Id.bs.js");
var CommonTypes_Business = require("./business/CommonTypes_Business.bs.js");
var StripeTypes_Customer = require("../bindings/StripeTypes_Customer.bs.js");
var CommonTypes_Business_Id = require("./business/CommonTypes_Business_Id.bs.js");

var Raw = {};

var query = "fragment CommonTypes_Invoice_Business on Business   {\nbusinessName  \nbusinessPayNotes  \nid  \nnetFeeAmount  \npaymentType  \nstripeCustomerId  \nusersByProfileableId(condition: {profileableType: \"Business\"}, first: 1)  {\nnodes  {\ncity  {\n...CommonTypes_City   \n}\n\nid  \n}\n\n}\n\n}\n" + CommonTypes_City.query;

function parse(value) {
  var value$1 = value.businessPayNotes;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var tmp$1 = value$1 === "STRIPE_NEED_APPROVAL" ? "STRIPE_NEED_APPROVAL" : ({
          NAME: "FutureAddedValue",
          VAL: value$1
        });
    tmp = tmp$1;
  }
  var value$2 = value.paymentType;
  var tmp$2;
  if (value$2 == null) {
    tmp$2 = undefined;
  } else {
    var tmp$3;
    switch (value$2) {
      case "NET_15" :
          tmp$3 = "NET_15";
          break;
      case "NET_30" :
          tmp$3 = "NET_30";
          break;
      case "STRIPE_ACH" :
          tmp$3 = "STRIPE_ACH";
          break;
      case "STRIPE_CC" :
          tmp$3 = "STRIPE_CC";
          break;
      default:
        tmp$3 = {
          NAME: "FutureAddedValue",
          VAL: value$2
        };
    }
    tmp$2 = tmp$3;
  }
  var value$3 = value.stripeCustomerId;
  var value$4 = value.usersByProfileableId;
  var value$5 = value$4.nodes;
  return {
          businessName: value.businessName,
          businessPayNotes: tmp,
          id: CommonTypes_Business_Id.GraphQL_API.parse(value.id),
          netFeeAmount: GraphqlHelpers.Float.parse(value.netFeeAmount),
          paymentType: tmp$2,
          stripeCustomerId: !(value$3 == null) ? Caml_option.some(Curry._1(StripeTypes_Customer.Id.GraphQL_API.parse, value$3)) : undefined,
          usersByProfileableId: {
            nodes: value$5.map(function (value) {
                  if (value == null) {
                    return ;
                  }
                  var value$1 = value.city;
                  return {
                          city: CommonTypes_City.verifyArgsAndParse("CommonTypes_City", value$1),
                          id: CommonTypes_User_Id.GraphQL_API.parse(value.id)
                        };
                })
          }
        };
}

function serialize(value) {
  var value$1 = value.usersByProfileableId;
  var value$2 = value$1.nodes;
  var nodes = value$2.map(function (value) {
        if (value === undefined) {
          return null;
        }
        var value$1 = value.id;
        var value$2 = Curry._1(CommonTypes_User_Id.GraphQL_API.serialize, value$1);
        var value$3 = value.city;
        var city = CommonTypes_City.serialize(value$3);
        return {
                city: city,
                id: value$2
              };
      });
  var usersByProfileableId = {
    nodes: nodes
  };
  var value$3 = value.stripeCustomerId;
  var stripeCustomerId = value$3 !== undefined ? Curry._1(StripeTypes_Customer.Id.GraphQL_API.serialize, Caml_option.valFromOption(value$3)) : null;
  var value$4 = value.paymentType;
  var paymentType = value$4 !== undefined ? (
      typeof value$4 === "string" ? (
          value$4 === "NET_15" ? "NET_15" : (
              value$4 === "NET_30" ? "NET_30" : (
                  value$4 === "STRIPE_ACH" ? "STRIPE_ACH" : "STRIPE_CC"
                )
            )
        ) : value$4.VAL
    ) : null;
  var value$5 = value.netFeeAmount;
  var value$6 = GraphqlHelpers.Float.serialize(value$5);
  var value$7 = value.id;
  var value$8 = Curry._1(CommonTypes_Business_Id.GraphQL_API.serialize, value$7);
  var value$9 = value.businessPayNotes;
  var businessPayNotes = value$9 !== undefined ? (
      typeof value$9 === "string" ? "STRIPE_NEED_APPROVAL" : value$9.VAL
    ) : null;
  var value$10 = value.businessName;
  return {
          businessName: value$10,
          businessPayNotes: businessPayNotes,
          id: value$8,
          netFeeAmount: value$6,
          paymentType: paymentType,
          stripeCustomerId: stripeCustomerId,
          usersByProfileableId: usersByProfileableId
        };
}

function verifyArgsAndParse(_CommonTypes_Invoice_Business, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var match = param.usersByProfileableId.nodes;
  if (match.length !== 1) {
    return ;
  }
  var match$1 = match[0];
  if (match$1 !== undefined) {
    return Relude_Option.pure({
                businessUserId: match$1.id,
                city: CommonTypes_City.tToR(match$1.city),
                id: param.id,
                name: param.businessName,
                netFeeAmount: param.netFeeAmount,
                paymentNotes: Relude_Option.map(CommonTypes_Business.PaymentNotes.parseApiResponse, param.businessPayNotes),
                paymentType: Relude_Option.map(CommonTypes_Business.PaymentType.parseApiResponse, param.paymentType),
                stripeCustomerId: param.stripeCustomerId
              });
  }
  
}

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
/* Relude_Option Not a pure module */
